<template>
  <div class="myQrCode" :style="`padding-top:${couponCardHeight}px`">
    <div v-for="(getshopQrDetail,index) in getshopQrDetails" :key="index" :class="{'borderBottom' : getshopQrDetails.length > 1}"  :style="[
        $route.query.tab
          ? { paddingTop: '65px' }
          : { paddingTop: '65px' },
      ]">
      <!-- {{getshopQrDetails.length}} -->
      <div class="qr-code-detail"  v-if="getshopQrDetail.sellerLiteDTO" :class="{'lessMargin': $cookie.get('version-code') >= 89}">
        <p class="shop-image"><img :src="getshopQrDetail.sellerLiteDTO.shopImage" /></p>
        <p class="shop-name">{{ getshopQrDetail.sellerLiteDTO.storeName }}</p>
        <p class="shop-address">
          <span class="material-icons" style="font-size: 1.25em">location_on</span
          >{{
            getshopQrDetail.sellerLiteDTO.sellerShopAddress.address +
            " " +
            getshopQrDetail.sellerLiteDTO.sellerShopAddress.city+ ' ' +
            getshopQrDetail.sellerLiteDTO.sellerShopAddress.zipCode
          }}
        </p>
        <p class="shop-qr-image"><img :src="getshopQrDetail.qrcodeImage" /></p>
        <p class="link-qrcode" @click="openLinkQrScanner(getshopQrDetail.sellerLiteDTO.shopId)">Link Your Sticker QR Code</p> 
      </div>
      <div class="qr-info" v-if="getshopQrDetail.sellerLiteDTO">
        <p class="note">
          Share this with your customers. Tell them to scan it to complete their order delivery.
        </p>
        <div v-if="$cookie.get('version-code') >= 89">
        <p class="download-qr" v-if="getshopQrDetail.qrcodeImage" @click="downloadQRcode(getshopQrDetail.qrcodeImage)">Download QR Code</p>
        <button class="download-button" type="button" @click="downLoadQR(getshopQrDetail.qrcodeImage, getshopQrDetail.shareMessage)" style="width:50%" v-if="getshopQrDetail.qrcodeImage && getshopQrDetail.shareMessage">Share QR Code</button>
        </div>
        <div v-else>
          <button class="download-button" v-if="getshopQrDetail.qrcodeImage && getshopQrDetail.shareMessage" type="button" @click="downLoadQR(getshopQrDetail.qrcodeImage, getshopQrDetail.shareMessage)" :class="{'topMargin': $cookie.get('version-code') < 89}">Download and Share QR Code</button>
        </div>
      </div>
    </div>
    <Scanner
      v-if="isScannerOpen"
      :isGlobalScanner="true"
      @orderId="getOrderId"
      @closeScanner="isScannerOpen = !isScannerOpen"
    />
    <div class="cntntLoad" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
  </div>
</template>

<script>
import constant from "../../utils/constant";
import CustomToaster from "../../components/Common/CustomToaster";
import ApiCaller from "../../utils/apicaller";
import RightArrow from "../../components/Icons/RightArrow";
import Vue from "vue";
import axios from "axios";
export default {
  name: "MyQrCode",
  components: {
    Scanner: () => import('../../components/Scanner'),
    CustomToaster,
    RightArrow,
  },
  props: {
    getshopQrDetails: {
      type: Array
    },
    couponCardHeight: {

    }
  },
  data() {
    return {
      isToasterData: false,
      isScannerOpen: false,
      loading: false,
      shopId: ''
      // shopQrDetail: {},
    };
  },
  methods: {
    downloadQRcode(link){
      try {
        JSBridgePlugin.downloadFile(
          link
        );
      } catch {
        window.open("whatsapp://send?text=" + link);
      }
    },
    shareMessage(shareMessage){
       try {
          JSBridgePlugin.share(shareMessage);
        } catch (err) {
          console.log(err);
          window.open("whatsapp://send?text=" + shareMessage);
        }
    },
    downLoadQR(link, message) {
      try {
        JSBridgePlugin.downloadVideoAndShare(
          link, message
        );
      } catch {
        window.open("whatsapp://send?text=" + link);
      }
    },
    openLinkQrScanner(shopid){
      this.isScannerOpen = !this.isScannerOpen;
      this.shopId = shopid
    },
    getOrderId(_orderId) {
      this.loading = true;
        const obj = {
          shop_id: this.shopId,
          qrCodeText: _orderId
        }
        console.log(this.shopId,_orderId)
        ApiCaller(constant.SHOP_SERVICE_URL , 'linkQr', "post" , obj)
        .then((data) => {
          this.loading = false;
          this.isScannerOpen = false;
          this.toasterData = {
            msg: 'Your new sticker QR Code is now linked to your Shop. Display it at your Shop to get more orders!',
            color: "#138808",
            iconName: "close",
          };
          this.isToasterData = true;
          return false;
          this.$emit('getLinkedQr')
        })
        .catch(err => {
          this.loading = false;
          this.isScannerOpen = false;
          console.log(err)
          if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.getOrderId(_orderId);
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }else{
              this.toasterData = {
                  msg: 'Invalid QR code',
                  color: "#e51c24",
                  iconName: "close",
                };
                this.isToasterData = true;
                return false;

            }
        });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.lessMargin{
  margin-top: 43px;
}
.topMargin{
  margin-top: 10px;
}
.borderBottom{
  border-bottom: 4px dashed #ccc;
  &:last-child{
    border-bottom: 0;
  }
}
.link-qrcode{
    font-size: 0.938em;
    color: #0063D3;
    font-weight: 500;
    text-decoration: underline;
}
</style>